module.exports = __webpack_public_path__ + "static/ipsos-c3399719452bdb3e0cd64ce666c5f6b0.png";